namespace Core {

    const DTCM_FLAGS = {
        LANDING_PAGE: 'landingPage',
        HOTEL_SEARCH_PAGE: 'hotelSearchPage',
        HOTEL_SELECTED_PAGE: 'hotelSelectedPage',
        BOOKING_OPTIONS_PAGE: 'bookingOptionsPage',
        PAYMENT_DETAILS_PAGE: 'paymentDetailsPage',
        BOOKING_COMPLETE_PAGE: 'bookingCompletePage'
    };

    export class DtcmService {
        private flags: string[] = [];

        constructor() {
            this.flags = DtcmService.getFlags();
        }

        public isEnabledFlag(flagName: string): boolean {
            return this.flags.indexOf(flagName) !== -1;
        };

        private static getFlags(): string[] {
            if (TRPCONFIG.Domain && TRPCONFIG.Domain.DTCMTrackingFlags instanceof Array) {
                return TRPCONFIG.Domain.DTCMTrackingFlags.map(flagName => flagName.trim());
            }
            return [];
        };

        public getTrackingId(): string {
            return TRPCONFIG.Domain.DTCMTrackingId;
        }
    }

    angular
        .module('core')
        .constant('DTCM_FLAGS', DTCM_FLAGS)
        .service('dtcmService', DtcmService);
}
